import { createContext } from 'react';

import { RouterContextState } from '../lib/types';

export const RouterContext = createContext<RouterContextState>(null!);
